<template>
  <div class="filtro-table">
    <div class="filtro-bloco-input">
      <form @submit.prevent="onSubmit">
        <Select class="filtro-select" label="Tipo busca" v-model="tipo" :options="options" />
        <Input :type="getInputType" class="filtro-input" label="Busca" v-model.trim="busca"/>
        <div style="text-align: right">
          <v-btn type="submit" class="filtro-buscar" small color="cyan">Buscar</v-btn>
        </div>
      </form>
    </div>

    <transition name="filtro-table-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <v-card v-if="exibirFiltro" class="pa-3 mb-3">
        <div style="display: flex">
          <div style="color: gray"><strong>Filtro</strong></div>
          <v-spacer></v-spacer>
          <v-icon @click="fechar">close</v-icon>
        </div>
        <div class="filtro-bloco-busca">
          <div class="filtro-itens">
            <div><strong>Tipo:</strong> {{ exibirTipo }}</div>
            <div>
              <strong>Busca: </strong>
              <span v-if="getInputTypeFiltred === 'date'">{{ buscaFiltro | formatDataBR }}</span>
              <span v-else>{{ buscaFiltro }}</span>
            </div>
          </div>
          <div>
            <strong>Resultados Encontrados:</strong> {{ quantidadeResultados }}
          </div>
        </div>
      </v-card>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FiltroTable',
  props: {
    options: Array,
    quantidadeResultados: {
      type: [Number, String],
      default: 0,
    }
  },
  watch: {
    tipo() {
      this.busca = '';
    },
  },
  created() {
    if(this.options.length > 0) { this.tipo = this.options[0].value; }
  },
  data() {
    return {
      busca: '',
      tipo: '',
      exibirFiltro: false,
      buscaFiltro: '',
      tipoFiltro: '',
    };
  },
  methods: {
    onSubmit() {
      // if(!this.busca) { return; }

      this.buscaFiltro = this.busca;
      this.tipoFiltro = this.tipo;

      this.$emit('filtro', {
        exibir: true,
        filtro: {
          [this.tipo]: this.busca,
        },
      });
    },
    fechar() {
      this.buscaFiltro = '';
      this.tipoFiltro = '';

      this.$emit('filtro', {
        exibir: false,
        filtro: {},
      });
    },
    getDataOptions(kindTipo, index) {
      return this.options.reduce((total, valor) => {
        if(valor.value === this[kindTipo]) { return valor[index]; }
        return total;
      }, '');
    }
  },
  computed: {
    getInputType() {
      return this.getDataOptions('tipo', 'type');
    },
    getInputTypeFiltred() {
      return this.getDataOptions('tipoFiltro', 'type');
    },
    exibirTipo() {
      return this.getDataOptions('tipoFiltro', 'text');
    }
  }
}
</script>

<style lang="scss">
.filtro-table {
  .filtro-bloco-input form {
    display: inline-flex;
    width: 60%;
    gap: 10px;
    .filtro-input,  {
      width: 400px;
    }
    .filtro-select {
      width: 200px;
    }
    .filtro-buscar {
      color: white;
      visibility: hidden;
    }
  }

  .filtro-bloco-busca {
    font-size: 16px;

    .filtro-itens {
      display: flex;
      flex-wrap: wrap;
      div {
        min-width: 300px;
        margin-right: 10px;
      }
    }
  }
}

@media only screen and (max-width: 600px){
  .filtro-table {
    margin: 10px 0px;
    .filtro-bloco-input form {
      display: block;
      width: 100%;
      .filtro-input,  {
        width: 100%;
      }
      .filtro-select {
        width: 100%;
      }
      .filtro-buscar {
        visibility: inherit;
      }
    }
  }
}
</style>
